import React, { useContext } from 'react';
import { Button, Stack, More, Modal } from 'components/kit';
import { context as localeContext } from 'context/locale';
import * as translations from 'constants/translations';
import { breadcrumbs } from 'constants/translations';
import { Breadcrumbs } from 'components/common/dashboard';
import { Text, Link } from 'components/service';
import { getBackUrl } from 'utils/history';
import * as paths from 'paths.js';
import cx from 'classnames';
import DeleteModal from './DeleteModal';

export default ({ branch, storeId, isSubmitting }) => {
  const { lang, direction } = useContext(localeContext);
  return (
    <Modal>
      {({ open, close }) => (
        <div className={cx(lang === 'ar' && 'flex-row-reverse')}>
          <Breadcrumbs
            links={[paths.setup, paths.branchList]}
            path={breadcrumbs.SETUP_EDIT_BUSINESS_LOCATION}
            right={
              <Stack
                className={cx(lang === 'ar' ? 'mr-auto flex-row-reverse' : 'ml-auto')}
                direction="wrap"
                expandItem={false}
                spacing="2"
              >
                <Button kind="primary" isSpinning={isSubmitting} data-testid="save-location-changes">
                  <Text value={translations.SAVE_CHANGE} />
                </Button>
                <Link omitQuery to={getBackUrl() || paths.branchList}>
                  <Button type="button" kind="secondary" data-testid="cancel-location-changes">
                    <Text value={translations.CANCEL} />
                  </Button>
                </Link>
                <More
                  items={[
                    {
                      title: <Text value={translations.DELETE} />,
                      onClick: () =>
                        open({
                          title: <Text value={branch} />,
                          body: <DeleteModal id={branch.id} storeId={storeId} onClose={close} />,
                          size: 'max-w-md',
                        }),
                    },
                  ]}
                />
              </Stack>
            }
          />
        </div>
      )}
    </Modal>
  );
};
